import {
  Box,
  createStyles,
  LinearProgress,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { H2 } from 'app/components/Typography';
import { Button } from 'app/components/BasicButtons/Button';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import clsx from 'clsx';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

export interface PopupImportExportProgressProps {
  title: string;
  info: string;
  buttonName: string;
  onClick: () => void;
}
export function PopupImportExportProgress(
  props: PopupImportExportProgressProps,
) {
  const classes = useStyles();
  return (
    <>
      <Box className={clsx(classes.root)}>
        <Box style={{ height: '85%' }} className={clsx(classes.container)}>
          <Box style={{ width: '40%', textAlign: 'center' }}>
            <H2>{props.title}</H2>
            <LinearProgress
              style={{ marginTop: '10px', marginBottom: '10px' }}
            />
            {props.info}
          </Box>
        </Box>
        <Box style={{ height: '15%' }} className={clsx(classes.container)}>
          <Button variant="white" onClick={props.onClick}>
            <Icon icon="times" size="xs" style={{ marginRight: '5px' }} />
            {props.buttonName}
          </Button>
        </Box>
      </Box>
    </>
  );
}
